import React, { useEffect, useState } from 'react'
import doMoreWithFontsImg from '../../assets/images/do_more_with_fonts.svg'
import accordingArrow from '../../assets/images/rateExpIcon.svg';
import Button from '../buttons/Button';
import arrowIcon from '../../assets/images/whiteArrowIcon.svg';
import axiosTokenInstance from '../../services/axiosInstance';
import { showToast } from '../../redux/toasterSlice';
import ModalsWrapper from '../Wrappers/ModalsWrapper';
import FeedbackSubmited from './FeedbackSubmited';
import { useDispatch } from 'react-redux';
import ReactGA from "react-ga4";

const DoMoreWithFonts = ({ onClose, imageData }) => {
    const dispatch = useDispatch()
    const [comment, setComment] = useState('')
    const [isOpenShareFeedback, setIsOpenShareFeedback] = useState(false)
    const [shareFeedbackLoading, setShareFeedbackLoading] = useState(false)
    const [openShareFeedbackSuccessModal, setOpenShareFeedbackSuccessModal] = useState(false)
    const [isShareFeedbackSuccess, setIsShareFeedbackSuccess] = useState(false)
    const guid = localStorage.getItem("guid")
    const [checkboxes, setCheckboxes] = useState({
        checkbox1: false,
        checkbox2: false,
        checkbox3: false,
        checkbox4: false,
    });

    const handleCheckboxChange = (key) => {
        setCheckboxes((prevCheckboxes) => ({
            ...prevCheckboxes,
            [key]: !prevCheckboxes[key],
        }));
    };

    const isFeedbackEmpty =
        !checkboxes.checkbox1 &&
        !checkboxes.checkbox2 &&
        !checkboxes.checkbox3 &&
        !checkboxes.checkbox4 &&
        !comment.trim();


    const handleSubmitFeedback = async () => {
        setShareFeedbackLoading(true);

        const feedbackData = {
            _id: imageData._id,
            checkbox1: checkboxes.checkbox1,
            checkbox2: checkboxes.checkbox2,
            checkbox3: checkboxes.checkbox3,
            checkbox4: checkboxes.checkbox4,
            additionalComment: comment,
        };

        const isFeedbackEmpty =
            !checkboxes.checkbox1 &&
            !checkboxes.checkbox2 &&
            !checkboxes.checkbox3 &&
            !checkboxes.checkbox4 &&
            !comment.trim();

        if (isFeedbackEmpty) {
            dispatch(showToast({ message: "Please provide feedback before submitting", type: "error" }))
            setShareFeedbackLoading(false);
            return;
        }

        try {
            const response = await axiosTokenInstance.post(`/general-feedback`, feedbackData);


            if (response.status === 201 || response.status === 200) {
                setIsShareFeedbackSuccess(true);
                ReactGA.gtag('event', 'after_download_feedback', {
                    action: 'General feedback after download',
                    label: 'General feedback after download'
                });

                onClose()
                // dispatch(openShareFeedbackFeedbackThankYou());
                // dispatch(setUpdateUserData(response.data));
            }
        } catch (error) {
            // dispatch(closeShareDownloadFeedbackModal());
            // dispatch(openShareFeedbackFeedbackError());
            setIsShareFeedbackSuccess(false);
            onClose()
        }
        setOpenShareFeedbackSuccessModal(true);
    };

    useEffect(() => {
        if (imageData) {
            setCheckboxes({
                checkbox1: imageData.checkbox1,
                checkbox2: imageData.checkbox2,
                checkbox3: imageData.checkbox3,
                checkbox4: imageData.checkbox4,
            });
            setComment(imageData.additionalComment || "");
        }
    }, [imageData]);

    const domoreWithFonts = () => (
        <div className='h-[492px] w-[773px] rounded-[16px] p-[40px]'>
            <div className='h-full flex gap-[24px]'>
                <img className='h-[380px] w-[285px] object-cover' src={doMoreWithFontsImg} alt="do More With FontsImg" />
                <div className='h-full flex justify-between flex-col '>
                    <div className='flex flex-col gap-[24px]'>
                        <div className='flex flex-col gap-[4px]'>
                            <h2 className='text-[28px] leading-[32px] tracking-[-0.01em] text-cus_primary font-helveticaText-Bold'>Do more with fonts!</h2>
                            <p className=' leading-[24px] tracking-[-0.02em] text-cus_secondary '>Use in Figma, Photoshop, Illustrator, InDesign and so much more</p>
                        </div>
                        <hr />
                        <div className='flex flex-col gap-[4px]'>
                            <p className='small-texts text-cus_secondary leading-[16px]'>Font used</p>
                            <h3 className='leading-[24px] tracking-[0.02em] font-helveticaText-Medium'>{imageData.fontFamily}</h3>
                        </div>
                    </div>
                    <div className='flex flex-col gap-[24px]'>
                        <div className='h-[40px] small-texts leading-[24px] flex items-center justify-between border-y'>
                            <p className=' text-cus_primary'>How do you plan on using the image?</p>
                            <p onClick={() => setIsOpenShareFeedback(true)} className='flexCenter gap-[2px] text-pink-primary cursor-pointer'>
                                <span>Tell us</span>
                                <span className='h-[16px] w-[16px] flexCenter'>
                                    <img src={accordingArrow} className='h-[8.5px] w-[5px]' alt="" />
                                </span>
                            </p>
                        </div>
                        <div className='flex items-center gap-[16px]'>
                            <Button onClick={onClose} label='Close' className="h-[40px] font-helveticaText-Medium flexCenter bg-gray-light hover:bg-gray-hoverLight text-cus_primary " />
                            <a
                                href={`https://enterprise.monotype.com/en/family/${imageData.fontFamilyUrl}?utm_source=portrait&utm_medium=${imageData?.md5hash}&utm_campaign=${guid}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={(e) => {
                                    e.stopPropagation()
                                    ReactGA.gtag('event', 'font_redirect', {
                                        action: 'Redirection to Enterprise',
                                        label: `https://enterprise.monotype.com/en/family/${imageData?.fontFamilyUrl}`
                                    });
                                    }
                                }
                                className='h-[40px] w-[126px] flexCenter gap-[8px] bg-blue-primary text-white rounded-[8px]'
                            >
                                <span className='text-[13px] font-helveticaText-Medium leading-[24px] '>Get this font</span>
                                <img src={arrowIcon} alt="arrow icon" className='w-[16px] h-[16px]' />

                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

    const shareFeedback = () => (
        <div className='h-[552px] w-[542px] flex flex-col'>
            <div className="h-[96px] pt-[40px] pb-[24px] px-[24px] border-b">
                <h5 className="h-[32px] text-[28px] font-helveticaText-Medium leading-[32px] text-cus_primary">
                    Your feedback is appreciated
                </h5 >
            </div >
            <div className="py-[4px]">
                <div className="overflow-y-auto py-[24px] md:max-h-[270px] lg:max-h-[444px]  px-[40px]">
                    <div className="max-h-[396px] flex flex-col gap-[24px]">
                        <div className="flex flex-col gap-[24px]">
                            <p className="font-helveticaText-Medium text-[16px] leading-[24px] tracking-[-0.02em] text-cus_primary">
                                How do you plan on using the image?
                            </p>
                            <div className="flex flex-col gap-[16px]">
                                {[
                                    { key: "checkbox1", label: "Client presentation" },
                                    { key: "checkbox2", label: "Internal brainstorming" },
                                    { key: "checkbox3", label: "Final design or mock-up" },
                                    { key: "checkbox4", label: "Personal use" },
                                ].map(({ key, label }) => (
                                    <div className="flex items-center gap-[8px]" key={key}>
                                        <input
                                            type="checkbox"
                                            checked={checkboxes[key]}
                                            onChange={() => handleCheckboxChange(key)}
                                        />
                                        <p>{label}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <textarea
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder="Other..."
                            className="outline-none max-w-[438px] h-[80px] w-full border border-gray-300 rounded-md px-3 py-2 text-sm"
                        />
                    </div>
                </div>
            </div>
            <div className='h-[112px]'>
                <div className="flex  gap-[16px] px-10 pt-6 pb-10 border-t">
                    <Button onClick={() => setIsOpenShareFeedback(false)} label='Cancel' className="bg-gray-light hover:bg-gray-hoverLight text-cus_primary " />
                    <Button onClick={handleSubmitFeedback} disabled={shareFeedbackLoading || isFeedbackEmpty} label='Share feedback' className={`bg-blue-primary hover:bg-blue-dark text-white  ${(shareFeedbackLoading || isFeedbackEmpty) && 'opacity-[50%]'}`} />
                </div>
            </div>
            <ModalsWrapper open={openShareFeedbackSuccessModal} onClose={() => setOpenShareFeedbackSuccessModal(false)} >
                <FeedbackSubmited success={isShareFeedbackSuccess} onClose={() => setOpenShareFeedbackSuccessModal(false)} />
            </ModalsWrapper>
        </div >)


    return (
        <>
            {isOpenShareFeedback ? shareFeedback() : domoreWithFonts()}
        </>
    )
}

export default DoMoreWithFonts